export default "__VITE_ASSET__TFnutqOc__"